import React, { FC, ReactElement } from 'react';
import styles from './toasts.module.scss';
interface Props {
    content: string
}
const Message: FC<Props> = ({ content }): ReactElement => {
    return (
        <div className={styles.modal}>
            <div className={styles.info}>
                {content}
            </div>
        </div>
    )
}

export default Message
